<!-- =========================================================================================
  File Name: Stores.vue
  Description: Stores' list
  ----------------------------------------------------------------------------------------
  Item Name: FastWay - Stores list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>

  <div>
    <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-plus" class="add-button" :to="{name: 'store', params: { id: 0 }}"/>

    <div class="vx-card p-6">
      <ejs-grid
        ref="grid"
        :dataSource="data"
        locale='es-GT'
        :toolbar='toolbarOptions'
        :allowPaging="true"
        :pageSettings='pageSettings'
        :allowSorting='true'
        :sortSettings='sortOptions'
        :allowExcelExport='true'
        :toolbarClick='toolbarClick'
        :allowFiltering='true'
        :filterSettings='filterOptions'
      >
        <e-columns>
          <e-column field="id" headerText="ID" :isPrimaryKey="true" textAlign='Right' format="N0" width="100" :allowFiltering="false"/>
          <e-column field="storeNumber" headerText="Número" :template="cTemplate" displayValue="storeNumber" routeName="store" urlBase="/catalogs/store/" width="150"/>
          <e-column field="name" headerText="Nombre" :template="cTemplate" displayValue="name" routeName="store" urlBase="/catalogs/store/"/>
          <e-column field="cityName" headerText="Municipio" width="200" :filter='checkBoxFilter'/>
          <e-column field="stateName" headerText="Departamento" width="200" :filter='checkBoxFilter'/>
          <e-column field="statusName" headerText="Estado" width="150" :template='cTemplateStatus' :filter='checkBoxFilter'/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Filter} from '@syncfusion/ej2-vue-grids';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import CellRendererLink from '@/views/components/CRLinkS';
  import CheckBoxCellTemplate from '@/views/components/CheckBoxCellTemplate';
  import CellStatus from '@/views/components/CRStatus';

  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'grid': {
        'EmptyRecord': 'No se encontró informormación relacionada',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        pageSettings: {pageSize: 10},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'parentName', direction: 'Ascending'}, {field: 'name', direction: 'Ascending'}, {field: 'sequence', direction: 'Ascending'}]},
        statusId: null,
        loaded: false,
        cTemplate: function () {
          return {template: CellRendererLink, urlBase: '/catalogs/store/'};
        },
        cTemplateStatus: function () {
          return {template: CellStatus};
        },
        checkBoxTemplate: function () {
          return {template: CheckBoxCellTemplate};
        },
        filterOptions: {
          type: 'Menu'
        },
        checkBoxFilter: {
          type: 'CheckBox'
        }
      }
    },
    components: {
      CellRendererLink
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport, Filter]
    },
    computed: {
      data() {
        return this.$store.getters.storesList;
      }
    },
    methods: {
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          const stores = encodeURIComponent(JSON.stringify(this.$store.state.stores.list));
          const element = document.createElement('a');
          element.setAttribute('href', `data:application/json;charset=utf-8,${stores}`);
          element.setAttribute('download', 'AnforaStores.json');
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);

          const excelExportProperties = {
            fileName: "ListadoTiendas.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      edit(id) {
        this.$router.push(`/catalogs/store/${id}`).catch(() => {
        });
      }
    }
  }

</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';

  .add-button {
    position: fixed;
    bottom: 5%;
    right: 29px;
    z-index: 51000;
    box-shadow: 0 1px 20px 1px rgb(251, 67, 79);
  }
</style>
